import React from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import { SessionTimeoutWarning } from './SessionTimeoutWarning';
import { useAuth } from '@/hooks/useAuth';
import { useToast } from '@/hooks/use-toast';

export const SessionManager: React.FC = () => {
  const { user, signOut } = useAuth();
  const { toast } = useToast();

  const {
    isWarningShown,
    remainingTime,
    extendSession,
    formatRemainingTime
  } = useSessionTimeout({
    timeoutMinutes: 60,
    warningMinutes: 5,
    onWarning: () => {
      toast({
        title: "Sessão Expirando",
        description: "Sua sessão será encerrada em 5 minutos por inatividade.",
        variant: "destructive",
      });
    },
    onTimeout: () => {
      toast({
        title: "Sessão Encerrada",
        description: "Sua sessão foi encerrada por inatividade.",
        variant: "destructive",
      });
    }
  });

  const handleExtendSession = () => {
    extendSession();
    toast({
      title: "Sessão Renovada",
      description: "Sua sessão foi renovada com sucesso.",
    });
  };

  const handleLogout = async () => {
    await signOut();
    toast({
      title: "Logout Realizado",
      description: "Você foi desconectado com sucesso.",
    });
  };

  // Só renderizar se o usuário estiver logado
  if (!user) {
    return null;
  }

  return (
    <SessionTimeoutWarning
      isOpen={isWarningShown}
      remainingTime={remainingTime}
      formatRemainingTime={formatRemainingTime}
      onExtendSession={handleExtendSession}
      onLogout={handleLogout}
    />
  );
};
